import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NgxMaskPipe } from 'ngx-mask';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'finance-transaction-list-totalitem',
  imports: [TranslatePipe, NgxMaskPipe, SkeletonModule],
  providers: [],
  templateUrl: './finance-transaction-list-totalitem.html',
  styleUrl: './finance-transaction-list-totalitem.scss',
})
export class FinanceTransactionListTotalItemComponent {
  @Input() total: number;
  @Input() totalPending: number;
}
